import './GridCards.scss';

function GridCards({
  tag,
  title,
  subtitle,
  cards = [],
  className = '',
}) {
  return (
    <section className={`grid-cards ${className}`}>
      <div className="grid-cards__container">
        {(tag || title || subtitle) && (
          <div className="grid-cards__header">
            {tag && <span className="grid-cards__tag">{tag}</span>}
            {title && <h2 className="grid-cards__title">{title}</h2>}
            {subtitle && <p className="grid-cards__subtitle">{subtitle}</p>}
          </div>
        )}

        <div className="grid-cards__grid">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`grid-cards__card ${card.highlighted ? 'grid-cards__card--highlighted' : ''}`}
            >
              {card.badge && <span className="grid-cards__card-badge">{card.badge}</span>}
              {card.title && <h3 className="grid-cards__card-title">{card.title}</h3>}
              {card.price && <div className="grid-cards__card-price">{card.price}</div>}
              {card.period && <div className="grid-cards__card-period">{card.period}</div>}

              {card.features && card.features.length > 0 && (
                <ul className="grid-cards__card-features">
                  {card.features.map((feature, fi) => (
                    <li key={fi} className="grid-cards__card-feature">{feature}</li>
                  ))}
                </ul>
              )}

              {card.action && (
                <div className="grid-cards__card-action">{card.action}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default GridCards;
